import comp from "./CurriculumList";
export default comp;
